export const MONTH_VIEW = 'MONTH_VIEW';
export const WEEK_VIEW = 'WEEK_VIEW';
export const DAY_VIEW = 'DAY_VIEW';
export const MONTH_VIEW_OUTSIDE = 'MONTH_VIEW_OUTSIDE';
export const WEEK_VIEW_OUTSIDE = 'WEEK_VIEW_OUTSIDE';
export const DAY_VIEW_OUTSIDE = 'DAY_VIEW_OUTSIDE';
export const LIST_VIEW = 'LIST_VIEW';
